module.exports = __webpack_public_path__ + "img/suppliers_xuanzhong.5f20ebb6.png";